import { useQuery } from "@tanstack/react-query";
import { AxiosResponse } from "axios";
import {
  ClassificationEntry,
  ShadowTestClassificationsResponse,
  Stage,
} from "../lusca-search-api/generated-src";
import { ShadowTestApiFactory } from "../lusca-search-api/LuscaSearchApiFactory";

const EMPTY_CLASSIFICATIONS: Record<string, ClassificationEntry> = {};

export default function useClassifications(stage: Stage | undefined) {
  const shadowTestApi = ShadowTestApiFactory();

  const { data } = useQuery<Record<string, ClassificationEntry>>(
    ["shadowTestClassifications", stage],
    async () => {
      const { data }: AxiosResponse<ShadowTestClassificationsResponse> =
        await shadowTestApi.getShadowTestClassifications(stage!);
      const map: Record<string, ClassificationEntry> = {};
      for (const entry of data.classifications) {
        map[entry.code] = entry;
      }
      return map;
    },
    {
      enabled: !!stage,
      staleTime: Infinity,
      cacheTime: Infinity,
      refetchOnWindowFocus: false,
    }
  );

  return data || EMPTY_CLASSIFICATIONS;
}
